// @TODO [CX-663]: clean up this file when workspaces are removed

import { Recording } from '@hotjar/webapp/features/Playbacks/types';

const removeDomain = (url: string) => url.replace(/https?:\/\/.*\.com/, '');

export const getRecordingPath = (
  recording: Pick<Recording, 'url' | 'public_url'>,
  opener?: string | null,
  shared?: boolean | null,
  startTime?: number | null,
  extra?: { [key: string]: string | number },
): string => {
  // We remove the domain from the URL to ensure testing environments work fine
  const url = new window.URL(recording.url);

  // Add the opener
  if (opener) {
    url.searchParams.append('opener', opener);
  }

  // Public URL's, we remove the workspace and add the token
  if (shared && recording.public_url) {
    const token = recording.public_url.slice(recording.url.length).split('=')[1];

    if (token) {
      url.searchParams.delete('workspace_id');
      url.searchParams.append('token', token);
    }
  }

  // Add the startTime param
  if (Number.isInteger(startTime)) {
    url.searchParams.append('startTime', String(startTime));
  }

  // Add anything else that has been passed
  if (extra) {
    for (const key in extra) {
      url.searchParams.append(key, String(extra[key]));
    }
  }

  return removeDomain(url.href);
};
